// import { createBrowserHistory as createHistory } from 'history';

// const history = createHistory();

// export default history;

import { createBrowserHistory } from '@remix-run/router';

export const history = createBrowserHistory();
